import { router } from 'umi'
import { stringify } from 'querystring'
import lodash from 'lodash'
import moment from 'moment'
import { loadPlugins, updateConfig } from '@xiaoduo/plugin_sdk'
import { message } from 'antd'
import * as services from '@/services/user'
import model, { ModelWithState } from '@/utils/model'
import { LoginResult } from '@/types/user'
import { loginSensors, logoutSensors } from '@/utils/sensorsData'
import { DvaState } from '../types/react-redux'
import { isNewLayout, isTest } from '@/utils/utils'

export const appHubUrl = isTest ? 'https://www-dev-lane.xiaoduoai.com' : 'https://www.xiaoduoai.com'

export interface ModelState extends LoginResult {
  flow_manage_info: any
  screenAuth: boolean
  qualityRole: boolean
  refreshDuration: number
  is_buy_barracks: boolean
  showMonitorSetting: boolean
  dialogId: string
  dialogBeginTime: number
  showSync: boolean
  showRuleId?: string
  highlightId: string
  showCaseId?: string
  jdToken?: string
  wipeId?: string
  isBzjtSeller: boolean
  voc_info: any
  enterprise: any
}

const fetchDeposit = ({ url, data }) => {
  return fetch(url, {
    method: 'post',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  }).then((res) => res.json())
}

const fetchPayUrl = ({ url, data, header }) => {
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      ...header,
    },
    credentials: 'include',
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((error) => console.error('Error:', error))
}

// 计算到期剩余时间
export const calculateDaysDifference = (dateString = 20240930) => {
  const year = parseInt(String(dateString).substring(0, 4), 10)
  const month = parseInt(String(dateString).substring(4, 6), 10) - 1
  const day = parseInt(String(dateString).substring(6, 8), 10)

  const targetDate = new Date(year, month, day)
  const currentDate = new Date()
  const difference = targetDate - currentDate
  const daysDifference = Math.ceil(difference / (1000 * 3600 * 24))

  return daysDifference
}
const UserModel: ModelWithState<ModelState> = model.extend({
  namespace: 'user',

  state: {
    payUrl: '',
    enterprise: {},
    platform: '',
    user_info: {
      account_id: '',
      user_id: '',
      username: '',
      password: '',
    },
    company_info: {
      shot_name: '',
      company_id: '',
      seller_nick: '',
      pri_center_id: '',
      pri_center_token: '',
      platforms: [],
    },
    role_info: {
      name: '',
      page_permit: {
        checkedKeys: {
          checked: [],
          halfChecked: [],
        },
      },
      data_permit: 1,
      is_admin: false,
    },
    voc_info: {},
    is_buy_barracks: undefined,
    flow_manage_info: {
      manage_mode: undefined,
      status: undefined,
      total: '',
    },
    data_permit: {
      shops: [],
      snicks: [],
      group_desc: [],
      department_desc: [],
    },
    screenAuth: true, // 是否是宝尊 以前只有宝尊能看的路由现在全量开放
    qualityRole: false, // 人工自定义质检的权限
    refreshDuration: 0,
    dialogId: '', // 查看会话链接中的id
    wipeId: '', // 消除会话的消除记录id
    showMonitorSetting: false, // 是否显示实时监控的设置弹窗
    showSync: false, // 是否高亮高级模板的同步按钮
    showRuleId: undefined, // 质培任务中展示的规则id
    highlightId: '', // 高亮告警配置项的id
    showCaseId: undefined, // 会话案例展示案例详情id
    jdToken: undefined,
    isBzjtSeller: false, //是否是宝尊集团子账号 （是宝尊集团的账号并且是主账号或者不是宝尊集团的账号 都为false， 只有宝尊集团的子账号才会为true）

    app_info: {
      flow: {},
      app: {},
      plugins: [],
    },
  },

  effects: {
    *fetchUserInfo(_, { call, put, select }) {
      try {
        const response = yield call(services.fetchUserInfo)
        yield put({
          type: 'setState',
          payload: {
            ...response.data,
            refreshDuration: response.data.settings?.refresh?.default?.ext ?? 0,
          },
        })
        const tenantId = response?.data?.company_info?.pri_center_id
        if (tenantId) {
          const pluginMatchKey = `tenant_id=${tenantId}`
          loadPlugins(pluginMatchKey)
          updateConfig({ defaultMatchKey: pluginMatchKey })
        }
        yield put({
          type: 'setState',
          payload: {
            isBzjtSeller:
              response.data?.company_info?.shot_name === '宝尊集团' &&
              response.data?.user_info?.username !== response.data?.company_info?.shot_name,
          },
        })
        // yield put({ type: 'fetchQualityRole' })
        yield put({ type: 'handleUrlSearch' })
        return response
      } catch (error) {
        console.log(error)
      }
    },

    *login({ payload }, { call, put }) {
      const response = yield call(services.login, payload)
      if (!response.code) {
        // 无权限判断
        const isAdmin = lodash.get(response, 'data.role_info.is_admin')
        const checkedKeys =
          lodash.get(response, 'data.role_info.page_permit.checkedKeys.checked') || []
        if (!isAdmin && !(checkedKeys && checkedKeys.length)) {
          return {
            code: 1,
            message: '该账号的角色未分配权限，请联系管理员授权。',
          }
        }
        yield put({
          type: 'setState',
          payload: {
            ...response.data,
            user_info: {
              ...response.data.user_info,
              password: payload.password,
            },
          },
        })
        localStorage.setItem('ums-user', response.data?.user_info?.user_id)
        const tenantId = response?.data?.company_info?.pri_center_id
        if (tenantId) {
          const pluginMatchKey = `tenant_id=${tenantId}`
          loadPlugins(pluginMatchKey)
          updateConfig({ defaultMatchKey: pluginMatchKey })
        }
        yield put({
          type: 'setState',
          payload: {
            isBzjtSeller:
              response.data?.company_info?.shot_name === '宝尊集团' &&
              response.data?.user_info?.username !== response.data?.company_info?.shot_name,
          },
        })
        loginSensors(response)

        yield put({ type: 'fetchFirstRoutes' })
        // yield put({ type: 'fetchQualityRole' })
      }
      return response
    },

    // 权限获取，判断使用新旧自定义质检
    *fetchQualityRole(action, { call, put, select }) {
      const company_id = yield select((state) => state.user.company_info.company_id)
      const response = yield call(services.fetchQualityRole, { company_id })
      yield put({
        type: 'setState',
        payload: {
          qualityRole: response?.data?.enable || false,
        },
      })
    },

    // 获取第一路由
    *fetchFirstRoutes(action, { put }) {
      yield put({ type: 'global/fetchDataRoleCenter', payload: { content: 'user' } })
    },

    *logout(action, { call }) {
      const { href, origin } = window.location
      let redirect = href.replace(origin, '')
      // 避免从宝尊账号切换方太账号的时候出现歧义
      const value = redirect.split('/')[1]
      if (value.substring(0, 1) === '6') {
        redirect = '/data'
      }
      router.replace({
        pathname: '/user/login',
        search: stringify({ redirect }),
      })
      // if (window.location.pathname !== '/user/login') {
      //   yield call(services.logout)
      // }
      yield call(services.logout)
      localStorage.removeItem('ums-user')
      localStorage.removeItem('ums-platform')
      logoutSensors()
    },

    *switchPlatform({ payload }, { call, put }) {
      const response = yield call(services.switchPlatform, payload, '切换平台成功', '切换平台失败')
      localStorage.setItem('ums-platform', payload.platform)
      yield put({
        type: 'setState',
        payload: {
          platform: payload.platform,
        },
      })
      return response
    },

    *updatePassword({ payload }, { callWithMessage }) {
      const response = yield callWithMessage(
        services.updatePassword,
        payload,
        '修改密码成功,请重新登录',
        '修改密码失败'
      )
      return response
    },

    *followUpReminder({ payload }, { callWithMessage }) {
      const response = yield callWithMessage(
        services.followUpReminder,
        payload,
        '跟进提醒成功',
        '跟进提醒失败'
      )
      return response
    },

    *jumpToXlc({ payload }, { call, select }) {
      const company_info = yield select((state) => state.user.company_info)
      const user_info = yield select((state) => state.user.user_info)
      const resopnse = yield call(services.fetchXlcInfo, {
        short_name: company_info.shot_name,
        password: user_info.password,
        tenant_id: company_info.pri_center_id,
      })
      const isDev = origin.includes('dev') || origin.includes('localhost')
      const jumpUrl = isDev
        ? 'https://mc-dev-lane.xiaoduoai.com/'
        : 'https://training.xiaoduoai.com/'
      if (resopnse?.data?.cookie) {
        if (payload) {
          window.open(`${jumpUrl}?${resopnse.data.cookie}`)
        } else {
          window.open(jumpUrl)
        }
      } else {
        message.error('出错啦，未能成功跳转')
      }
    },

    *handleUrlSearch(_, { put, select }) {
      const company_id = yield select((state) => state.user.company_info.company_id)
      const searchMap = new URLSearchParams(window.location.search)

      // 打开高级搜索列表并高亮同步按钮
      if (searchMap.get('show_sync') === '1') {
        yield put({
          type: 'setState',
          payload: {
            showSync: true,
          },
        })
        router.replace({ pathname: isNewLayout ? '/qcManage/dialog/list' : '/dialog/list' })
        return
      }

      // 链接中没有company_id，或者和当前登录的company_id不一致时，不做任何操作
      if (!searchMap.has('company_id') || searchMap.get('company_id') !== company_id) {
        return
      }

      // 跳转案例会话
      if (
        window.location.pathname === '/qcManage/train/case' ||
        window.location.pathname === '/case/dialog'
      ) {
        const id = searchMap.get('id')
        if (id) {
          yield put({ type: 'setState', payload: { showCaseId: id } })
          router.replace(isNewLayout ? '/qcManage/train/case' : '/case/dialog')
        }
        return
      }

      // 跳转审批详情
      if (
        window.location.pathname === '/qcManage/train/approve/detail' ||
        window.location.pathname === '/case/approve/detail'
      ) {
        const id = searchMap.get('id')
        if (id) {
          router.replace(isNewLayout ? '/qcManage/train/approve' : '/case/approve')
          router.push({
            pathname: `${isNewLayout ? '/qcManage/train' : '/case'}/approve/detail/${id}`,
          })
        }

        return
      }

      // 跳转质培任务
      if (
        window.location.pathname === '/qcManage/train/tasks' ||
        window.location.pathname === '/train/tasks'
      ) {
        const id = searchMap.get('id')
        const showRuleId = searchMap.get('rule_id')
        if (id) {
          // 显示任务
          router.replace(isNewLayout ? '/qcManage/train/tasks' : '/train/tasks')
          router.push({ pathname: `${isNewLayout ? '/qcManage/train' : '/train'}/detail/${id}` })
        } else if (showRuleId) {
          // 显示规则
          yield put({ type: 'setState', payload: { showRuleId } })
          router.replace({ pathname: isNewLayout ? '/qcManage/train/tasks' : '/train/tasks' })
        }

        return
      }

      // 打开实时监控的设置弹窗
      if (
        window.location.pathname === '/riskMonitor/leaderMonitor' ||
        window.location.pathname === '/monitor/abnormals'
      ) {
        yield put({ type: 'setState', payload: { showMonitorSetting: true } })
        router.replace({
          pathname: isNewLayout ? '/riskMonitor/leaderMonitor' : '/monitor/abnormals',
        })
        return
      }

      // 没有id
      if (!searchMap.has('id')) {
        return
      }

      // 高亮显示告警配置项
      if (
        window.location.pathname === '/riskMonitor/alarm' ||
        window.location.pathname === '/alarm'
      ) {
        yield put({ type: 'setState', payload: { highlightId: searchMap.get('id') } })
        router.replace({ pathname: isNewLayout ? '/riskMonitor/alarm' : '/alarm' })
        return
      }

      if (!searchMap.has('platform')) {
        return
      }

      // 打开会话
      yield put({ type: 'switchPlatform', payload: { platform: searchMap.get('platform') } })
      yield put({ type: 'setState', payload: { dialogId: searchMap.get('id') } })

      // 跳转消除会话
      if (
        window.location.pathname === '/system/effectMonitor/eliminateLabels' ||
        window.location.pathname === '/system/eliminateLabels'
      ) {
        if (!searchMap.get('wipeId')) return

        yield put({
          type: 'setState',
          payload: { dialogId: searchMap.get('id'), wipeId: searchMap.get('wipeId') },
        })
        router.replace({
          pathname: isNewLayout
            ? '/system/effectMonitor/eliminateLabels'
            : '/system/eliminateLabels',
        })
        return
      }

      const beginTime = searchMap.get('begin')
      // 携带起始时间并且会话已超过30天
      if (beginTime && moment() > moment(Number(beginTime) * 1000).add(30, 'days')) {
        yield put({
          type: 'setState',
          payload: { dialogBeginTime: Number(searchMap.get('begin')) },
        })
        router.replace({ pathname: isNewLayout ? '/qcManage/dialog/history' : '/dialog/history' })
        return
      }

      router.replace({ pathname: isNewLayout ? '/qcManage/dialog/list' : '/dialog/list' })
    },

    *fetchJDToken(_, { select, call, put }) {
      const res = yield call(services.fetchJDToken)
      yield put({ type: 'setState', payload: { jdToken: res?.data?.encrypt_token } })
    },

    *resetPass({ payload }, { call }) {
      const res = yield call(services.resetPass, payload)
      return res
    },

    // 流量信息
    *enterprise({ payload }, { call, put }) {
      const response = yield call(fetchDeposit, {
        url: isTest
          ? 'https://console-dev-lane.xiaoduoai.com/flow/v2/scalar/cycle/enterprise'
          : 'https://console.xiaoduoai.com/flow/v2/scalar/cycle/enterprise',
        data: {
          model: 1, //// 0-普通  1-叠加实时
          ...payload,
        },
      })
      const resetNumber =
        Number(response.data?.data?.scalar_num) - Number(response.data?.data?.consume_num) || 0
      const restDay = calculateDaysDifference(response.data?.data?.end_day ?? 20241231)
      if (response.code === 0 && response.data) {
        yield put({
          type: 'setState',
          payload: {
            enterprise: {
              scalar_num: 0,
              consume_num: 0,
              ...response.data.data,
              end_day: response.data.data?.end_day ?? 20241231,
              resetNumber,
              restDay,
            },
          },
        })
        // 登陆后展示 刷新页面不展示
        if ((resetNumber <= 200 || restDay <= 30) && !localStorage.getItem('showTip')) {
          yield put({
            type: 'setState',
            payload: {
              showTip: true,
            },
          })
        }
      }
    },

    *fecthPayUrl({ payload }, { call, put, select }) {
      const { header, ...rest } = payload
      const { data } = yield call(fetchPayUrl, {
        url: isTest
          ? 'https://enterprise-dev-lane.xiaoduoai.com/api/app/item_by_key'
          : 'https://enterprise.xiaoduoai.com/api/app/item_by_key',
        data: {
          ...rest,
        },
        header,
      })

      const url = `${appHubUrl}/app/paying?paying_app_id=${data?.id}&paying_status=1&paying_product_key=mc&paying_plugin_key=null`
      yield put({
        type: 'setState',
        payload: {
          payUrl: url,
        },
      })
    },
  },
  reducers: {},
  subscriptions: {
    setup: ({ listen, dispatch }) => {
      listen(isNewLayout ? '/qcManage/dialog/list' : '/dialog', () => {
        dispatch({
          type: 'handleUrlSearch',
        })
      })

      listen(isNewLayout ? '/qcManage/train/case' : `/case`, () => {
        dispatch({
          type: 'handleUrlSearch',
        })
      })

      listen(
        isNewLayout ? '/system/effectMonitor/eliminateLabels' : '/system/eliminateLabels',
        () => {
          dispatch({
            type: 'handleUrlSearch',
          })
        }
      )
    },
  },
})

export default UserModel
